import useSWR from 'swr';
import { getJsonAsync } from './fetchConfig';

export const usePersonRolesById = personId => useSWR(`persons/${personId}/roles`);

export const getPersonRolesById = id =>  getJsonAsync(`persons/${id}/roles`);